<template>
  <el-dialog
    title="编辑"
    :visible.sync="visible"
    width="650px"
    custom-class="property-owner-form-dialog"
    :close-on-click-modal="false"
    @close="resetForm"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="86px" label-position="left" class="property-owner-form">
      <el-form-item label="人员类型" prop="personType">
        <el-select v-model="form.personType" placeholder="请选择" class="property-owner-control">
          <el-option v-for="type in personTypes" :key="type.value" :label="type.label" :value="type.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="所在小区" prop="communityId">
        <el-select v-model="form.communityId" placeholder="请选择" class="property-owner-control" @change="handleCommunityChange">
          <el-option v-for="community in communityOptions" :key="community.communityId" :label="community.name" :value="community.communityId" />
        </el-select>
      </el-form-item>
      <el-form-item label="人员角色" prop="personRole">
        <el-select v-model="form.personRole" placeholder="请选择" class="property-owner-control">
          <el-option v-for="role in personRoles" :key="role.value" :label="role.label" :value="role.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-select v-model="form.sex" placeholder="请选择" class="property-owner-control">
          <el-option v-for="gender in genders" :key="gender.value" :label="gender.label" :value="gender.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入" class="property-owner-control" />
      </el-form-item>
      <el-form-item label="联系电话" prop="link">
        <el-input v-model="form.link" placeholder="请输入" class="property-owner-control" />
      </el-form-item>
      <el-form-item label="证件号" prop="idCard">
        <el-input v-model="form.idCard" placeholder="请输入" class="property-owner-control" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入" class="property-owner-control" />
      </el-form-item>
      <el-form-item label="上传头像" prop="ownerPhoto" class="owner-photo-form-item">
        <el-upload
          class="owner-photo-uploader"
          action="#"
          :show-file-list="false"
          :before-upload="beforeUpload"
          :http-request="uploadImage"
        >
          <img v-if="form.ownerPhotoUrl" :src="form.ownerPhotoUrl" class="owner-photo-preview" />
          <div v-else class="owner-photo-placeholder">
            <i class="el-icon-plus"></i>
          </div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button class="property-owner-dialog-btn-cancel" @click="visible = false">取消</el-button>
      <el-button class="property-owner-dialog-btn-confirm" type="primary" @click="updateOwner">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { editOwner, getAttrValue, uploadImage } from '@/api/owner/ownerApi'
import { listMyEnteredCommunitys } from '@/api/community/communityManageApi'
import { getAttrSpecList } from '@/api/dev/attrSpecApi'

export default {
  name: 'EditOwner',
  data() {
    return {
      visible: false,
      form: {
        ownerId: '',
        name: '',
        link: '',
        address: '',
        sex: '',
        remark: '',
        ownerPhoto: '',
        ownerPhotoUrl: '',
        communityId: '',
        communityName: '',
        idCard: '',
        personType: '',
        personRole: '',
        concactPerson: '',
        concactLink: ''
      },
      attrs: [],
      communityOptions: [],
      personTypes: [
        { value: 'P', label: this.$t('listOwner.personType.personal') },
        { value: 'C', label: this.$t('listOwner.personType.company') }
      ],
      personRoles: [
        { value: '1', label: this.$t('listOwner.role.owner') },
        { value: '2', label: this.$t('listOwner.role.tenant') }
      ],
      genders: [
        { value: '0', label: this.$t('listOwner.gender.male') },
        { value: '1', label: this.$t('listOwner.gender.female') }
      ],
      rules: {
        name: [
          { required: true, message: '请输入客户姓名', trigger: 'blur' },
        ],
        personType: [
          { required: true, message: '请选择人员类型', trigger: 'change' }
        ],
        communityId: [
          { required: true, message: '请选择所在小区', trigger: 'change' }
        ],
        personRole: [
          { required: true, message: '请选择人员角色', trigger: 'change' }
        ],
        link: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(owner) {
      this.form = { ...owner }
      this.form.ownerPhotoUrl = owner.faceUrl || owner.ownerPhotoUrl || ''
      this.visible = true
      this.loadCommunityOptions()
      this.loadAttributes()
    },

    async loadCommunityOptions() {
      try {
        const res = await listMyEnteredCommunitys({ page: 1, row: 1000 })
        this.communityOptions = res.communitys || res.data || []
      } catch (error) {
        this.communityOptions = []
      }
    },

    handleCommunityChange(communityId) {
      const community = this.communityOptions.find(item => item.communityId === communityId)
      this.form.communityName = community ? community.name : ''
    },

    async loadAttributes() {
      try {
        const {data} = await getAttrSpecList({ page: 1, row: 100, tableName: 'building_owner_attr' })
        if (data.length == 0) {
          return
        }
        this.attrs = data.filter(item => item.specShow === 'Y')

        for (const attr of this.attrs) {
          attr.value = ''
          if (attr.specType === '3344') {
            attr.values = await getAttrValue(attr.specCd)
          }

          // 设置已有属性值
          if (this.form.ownerAttrDtos) {
            const attrDto = this.form.ownerAttrDtos.find(dto => dto.specCd === attr.specCd)
            attr.value = attrDto ? attrDto.value : ''
            attr.attrId = attrDto ? attrDto.attrId : ''
          }
        }
      } catch (error) {
        console.error('Failed to load attributes:', error)
      }
    },

    beforeUpload(file) {
      const isImage = file.type.indexOf('image/') === 0
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('请上传图片文件')
      }
      if (!isLt2M) {
        this.$message.error(this.$t('common.sizeLimit'))
      }
      return isImage && isLt2M
    },

    async uploadImage({ file }) {
      try {
        const res = await uploadImage({ file })
        this.form.ownerPhoto = res.fileId
        this.form.ownerPhotoUrl = res.url
        this.$forceUpdate()
      } catch (error) {
        this.$message.error(this.$t('listOwner.upload.failed'))
      }
    },

    async updateOwner() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          const params = {
            ...this.form,
            attrs: this.attrs.map(attr => ({
              attrId: attr.attrId,
              specCd: attr.specCd,
              value: attr.value
            }))
          }

          await editOwner(params)
          this.$message.success(this.$t('common.operationSuccess'))
          this.visible = false
          this.$emit('success')
        } catch (error) {
          this.$message.error(error)
        }
      })
    },

    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.form = {
        ownerId: '',
        name: '',
        link: '',
        address: '',
        sex: '',
        remark: '',
        ownerPhoto: '',
        ownerPhotoUrl: '',
        communityId: '',
        communityName: '',
        idCard: '',
        personType: '',
        personRole: '',
        concactPerson: '',
        concactLink: ''
      }
      this.attrs = []
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .property-owner-form-dialog {
  width: 650px;
  max-width: calc(100vw - 32px);
  height: 640px;
  margin-top: calc((100vh - 640px) / 2) !important;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
}

::v-deep .property-owner-form-dialog .el-dialog__header {
  height: 66px;
  padding: 0 24px;
  background: #EBF2FA;
  border-bottom: none;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

::v-deep .property-owner-form-dialog .el-dialog__title {
  color: #1D2129;
  font: 600 16px/22px 'PingFang SC', sans-serif;
}

::v-deep .property-owner-form-dialog .el-dialog__headerbtn {
  display: none;
}

::v-deep .property-owner-form-dialog .el-dialog__body {
  flex: 1;
  padding: 24px 24px 0;
  overflow-y: auto;
}

::v-deep .property-owner-form-dialog .el-dialog__footer {
  padding: 0 24px 28px;
  border-top: none;
  text-align: right;
}

.property-owner-form {
  ::v-deep .el-form-item {
    display: block;
    margin-bottom: 20px;
  }

  ::v-deep .el-form-item:last-child {
    margin-bottom: 0;
  }

  ::v-deep .el-form-item::after {
    content: '';
    display: table;
    clear: both;
  }

  ::v-deep .el-form-item__label {
    float: left;
    width: 86px !important;
    box-sizing: border-box;
    padding: 0 16px 0 0;
    color: #1D2129;
    font: 500 14px/38px 'PingFang SC', sans-serif;
    text-align: right;
  }

  ::v-deep .el-form-item__label::before {
    color: #FB2C36;
    margin-right: 0;
  }

  ::v-deep .el-form-item__content {
    width: calc(100% - 86px);
    margin-left: 86px !important;
    line-height: 38px;
  }

  ::v-deep .el-form-item__error {
    padding-top: 2px;
  }
}

.property-owner-control {
  width: 100%;
}

::v-deep .property-owner-control .el-input__inner {
  height: 38px;
  padding-left: 16px;
  border: 1px solid #DCE6F5;
  border-radius: 10px;
  color: #1D2129;
  font: 400 14px/38px Inter, 'PingFang SC', sans-serif;
}

::v-deep .property-owner-control .el-input__inner::placeholder {
  color: #8C9BB4;
}

.owner-photo-form-item {
  margin-bottom: 20px;
}

.owner-photo-uploader ::v-deep .el-upload {
  width: 82px;
  height: 82px;
  border: 1px solid #0E76FF;
  border-radius: 8px;
  background: rgba(14, 118, 255, 0.08);
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.owner-photo-preview {
  width: 82px;
  height: 82px;
  object-fit: cover;
  border-radius: 8px;
}

.owner-photo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0E76FF;
}

.owner-photo-placeholder i {
  font-size: 28px;
  font-weight: 400;
}

.dialog-footer {
  display: inline-flex;
  gap: 12px;
}

.property-owner-dialog-btn-cancel,
.property-owner-dialog-btn-confirm {
  width: 98px;
  height: 38px;
  padding: 0;
  border-radius: 10px;
  font: 500 14px/38px 'PingFang SC', sans-serif;
}

.property-owner-dialog-btn-cancel {
  border: 1px solid #0E76FF;
  color: #0E76FF;
  background: #FFFFFF;
}

.property-owner-dialog-btn-confirm {
  background: #0E76FF;
  border-color: #0E76FF;
}
</style>
